<template>
    <div class="madrid-quiz">
        <div v-if="type == QuizType.INIT" class="madrid-quiz__back" @click="goBack()"></div>
        <div v-if="type == QuizType.INIT">
            <h1>¡Prepárate para explorar Madrid!</h1>
            <p>Responde este pequeño formulario y estaremos listos para comenzar.</p>
            <div class="madrid-quiz__content">
                <div :class="{
                        'madrid-quiz__field--selected': v$.age.$model != null,
                        'madrid-quiz__field--opened': v$.age.$dirty && v$.age.$model == null
                    }">
                    <label>EDAD</label>
                    <v-select v-model="v$.age.$model" 
                        placeholder="Selecciona una franja de edad" 
                        :options="ageOptions" 
                        :searchable="false"
                        @close="v$.age.$touch()"
                        />
                </div>

                <div :class="{
                        'madrid-quiz__field--selected': v$.groupType.$model != null,
                        'madrid-quiz__field--opened': v$.groupType.$dirty && v$.groupType.$model == null
                    }">
                    <label>TIPO DE GRUPO</label>
                    <v-select v-model="v$.groupType.$model" 
                        placeholder="Selecciona el tipo de grupo" 
                        :options="groupOptions" 
                        :searchable="false" 
                        @option:selected="groupTypeChange"
                        @close="v$.groupType.$touch()"/>
                </div>

                <div class="madrid-quiz__field--input" :class="{
                        'madrid-quiz__field--selected': v$.groupNumber.$model != null && v$.groupNumber.$model != '',
                        'madrid-quiz__field--opened': v$.groupNumber.$dirty 
                        && (v$.groupNumber.$model == null || v$.groupNumber.$model == '')
                    }">
                    <label>NÚMERO DE PERSONAS DEL GRUPO</label>
                    <input v-model="v$.groupNumber.$model" type="number"
                     inputmode="numeric" @blur="v$.groupNumber.$touch()"
                    placeholder="Añade aquí el número de personas" />
                </div>

                <div :class="{
                        'madrid-quiz__field--selected': v$.gender.$model != null,
                        'madrid-quiz__field--opened': v$.gender.$dirty && v$.gender.$model == null
                    }">
                    <label>SEXO</label>
                    <v-select v-model="v$.gender.$model" 
                        placeholder="Selecciona una opción" 
                        :options="genderOptions" 
                        :searchable="false" 
                        @close="v$.gender.$touch()"/>
                </div>

                <div :class="{
                        'madrid-quiz__field--selected': v$.nationality.$model != null,
                        'madrid-quiz__field--opened': v$.nationality.$dirty && v$.nationality.$model == null
                    }">
                    <label>NACIONALIDAD</label>
                    <v-select v-model="v$.nationality.$model" 
                        placeholder="Selecciona una opción" 
                        :options="sortedCountries" 
                        :searchable="true" 
                        @option:selected="nationalitiyChange"
                        @close="v$.nationality.$touch()">
                        <template v-slot:no-options="{ search, searching }">
                            <template v-if="searching">
                                <span class="not-found">Sin resultados para <em>{{ search }}</em>.</span>
                            </template>
                        </template>
                    </v-select>
                </div>

                <div v-if="isSpanish" class="madrid-quiz__field--input" :class="{
                        'madrid-quiz__field--selected': v$.postalCode.$model != null && v$.postalCode.$model != ''
                         && !v$.postalCode.$error,
                        'madrid-quiz__field--opened': (v$.postalCode.$dirty 
                        && (v$.postalCode.$model == null || v$.postalCode.$model == '')) || v$.postalCode.$error
                    }">
                    <label>CÓDIGO POSTAL</label>
                    <input v-model="v$.postalCode.$model" type="number" inputmode="numeric"  placeholder="Ej: 24286" 
                    @blur="v$.postalCode.$touch()"/>
                </div>

                <div class="madrid-quiz__go" @click="saveQuiz()" :class="{'ox-disabled': isInvalid}">
                    <span>COMENZAR RUTA</span>
                    <span></span>
                </div>
            </div>
            <div class="madrid-quiz__footer">
                <p v-if="isInvalid" :class="{'madrid-quiz__footer--dirty': v$.$anyDirty && v$.$errors.length > 0}">
                    Por favor, completa todos los campos del formulario para poder comenzar.</p>
                <p v-else class="madrid-quiz__footer--correct">
                    ¡Todo listo! Ya puedes acceder a la ruta pulsando el botón ”Comenzar ruta”.</p>
                <p>La información que nos proporcionas será tratada de forma 
                    confidencial y utilizada únicamente para fines internos o estadísticos.</p>
                <div></div>
            </div>
        </div>
        <div v-if="type == QuizType.FINAL && !showFinal" class="madrid-quiz--final">
            <div></div>
            <h1>¿Nos ayudas a seguir mejorando?</h1>
            <p>Selecciona uno de los emojis para puntuar la ruta que acabas de realizar.</p>
            <div class="madrid-quiz__content">
                <div :class="{ 'any-selected': v$.points.$model != null }">
                    <div v-for="n in 5" :key="n" @click="selectPoints(n)" 
                        :class="{ 'points-selected': v$.points.$model == n }">
                        {{ getEmoji(n) }}
                    </div> 
                </div>
                
                <p>Y por último… selecciona la parada que más te haya gustado:</p>
                <div v-for="l of locations" :key="l" :class="{ 'item-selected': v$.item.$model == l}">
                    <span>{{ l }}</span>
                    <div @click="selectItem(l)"></div>
                </div>
                <div class="madrid-quiz__go" @click="saveQuiz()" :class="{'ox-disabled': isInvalid}">
                    <span>ENVIAR VALORACIÓN</span>
                    <span></span>
                </div>
            </div>
            <div class="madrid-quiz__footer">
                <p v-if="isInvalid" :class="{'madrid-quiz__footer--dirty': v$.$anyDirty && v$.$errors.length > 0}">
                    Por favor, completa todos los campos del formulario para poder comenzar.</p>
                <p v-else class="madrid-quiz__footer--correct">
                    ¡Todo listo! Ya puedes enviar tu valoración sobre esta ruta y finalizar.</p>
                <div></div>
            </div>
        </div>
        <div v-if="showFinal" class="madrid-quiz--end">
            <div></div>
            <h1>¡Gracias por tu valoración!</h1>
            <p>La ruta que estabas realizando ya ha finalizado. ¿Qué quieres hacer ahora?</p>
            <div @click="close(false)">SEGUIR EN LA RUTA ACTUAL</div>
            <div @click="close(true)">IR AL LISTADO DE RUTAS</div>
        </div>
    </div>
</template>
<script lang="ts" src="./QuizComponent.ts"></script>
<style lang="scss" src="./QuizComponent.scss"></style>
